import React, { useRef, useState } from 'react'

export const CartContext = React.createContext()
export default function CartProvider({ children }) {
  // Persisted state needed for useCart()
  const [showCart, setShowCart] = useState('')
  const interactingWithCart = useRef(false)

  return (
    <CartContext.Provider value={{ showCart, setShowCart, interactingWithCart }}>
      {children}
    </CartContext.Provider>
  )
}
